import UrlInformation from 'components/MessageExtensions/Information/Url/UrlInformation';
import { InformationExtensionType } from 'components/MessageExtensions/Information/types';
import { useEffect, useState } from 'react';

import { getPageMetadata } from 'utils/pageMetadata';
import { Sanitized } from 'utils/sanitize';
import { containsUrl, getUrl, linkifyMessage } from 'utils/url';
import { PlainTextMessage } from '../PlainTextMessage';
import { MESSAGE_ALIGN } from '../constants';
import { PlainTextMessageProps } from '../types';
import { Container } from './styles';

type TextMessageWithUrlProps = PlainTextMessageProps;
const TextMessageWithUrl = (props: TextMessageWithUrlProps) => {
  const { text, align } = props;
  if (typeof text !== 'string') return <PlainTextMessage {...props} />;

  const url = getUrl(text) ?? '';
  const [metadataInfo, setMetadataInfo] = useState<InformationExtensionType | null>(null);

  const hasUrl = containsUrl(text);

  if (!hasUrl.result) {
    return <PlainTextMessage {...props} />;
  }

  useEffect(() => {
    const getMeta = async () => {
      const result = await getPageMetadata(url);
      setMetadataInfo(result as InformationExtensionType);
    };
    getMeta();
  }, []);

  return (
    <Container>
      <PlainTextMessage
        {...props}
        text={<Sanitized text={align === MESSAGE_ALIGN.LEFT ? linkifyMessage(text) : text} />}
      />
      {metadataInfo && <UrlInformation content={metadataInfo} />}
    </Container>
  );
};

export default TextMessageWithUrl;
